import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './contact-form.css';

const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const ContactForm = () => {
    const [formValues, setFormValues] = useState({
        vorname: "",
        nachname: "",
        email: "",
        message: "",
        tel: ""
    });
    const [errors, setErrors] = useState();
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setFormValues({
            ...formValues,
            [e.target.name]: e.target.value
        });
        setErrors(null);
        setSuccess(false);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(formValues.vorname.trim() == "") {
            setErrors("Bitte geben sie einen Vornamen ein");
            document.getElementById("vorname").focus();
            return;
        }
        if(formValues.nachname.trim() == "") {
            setErrors("Bitte geben sie einen Nachnamen ein");
            document.getElementById("nachname").focus();
            return;
        }
        if(formValues.tel.trim() == "") {
            setErrors("Bitte geben sie eine Telefonnummer ein ein");
            document.getElementById("tel").focus();
            return;
        }
        if(formValues.message.trim() == "") {
            setErrors("Bitte geben sie eine Nachricht ein");
            document.getElementById("message").focus();
            return;
        }
        if(!formValues.email.match(mailformat)){
            setErrors("Bitte geben sie eine gültige E-Mail-Adresse an")
            document.getElementById("email").focus();
            return;
        }
        setFormValues(
            {
                vorname: "",
                nachname: "",
                email: "",
                message: "",
                tel: "",
            }
        );
        setErrors(null);
        setSuccess(true);
        
        emailjs.sendForm(process.env.REACT_APP_EMJS_SERVICE_ID, process.env.REACT_APP_EMJS_TEMPLATE_ID, e.target, process.env.REACT_APP_EMJSU)
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            alert("Da ist leider etwas schief gegangen. Bitte versuchen sie es noch einmal, oder kontaktieren sie mich direkt per Email");
        });
    }


    return(
        <form onSubmit={handleSubmit}>
            <div className="form-wrapper">
                <div className="form-row">
                    <p className="form-heading">Hallo.</p>
                </div>
                <div className="form-row">
                    <input type="text" value={formValues.name} name="vorname" id="vorname" onChange={handleChange} placeholder="Vorname" className="inp inp-name"></input>
                    <input type="text" value={formValues.name} name="nachname" id="nachname" onChange={handleChange} placeholder="Nachname" className="inp inp-name"></input>
                    
                </div>
                <div className="form-row">
                <input type="email" value={formValues.email} name="email" id="email" onChange={handleChange} placeholder="E-Mail-Adresse" className="inp inp-mail"></input>
                    <input type="tel" value={formValues.tel} name="tel" id="tel" onChange={handleChange} placeholder="Telefonnummer" className="inp inp-name"></input>
                </div>
                <div className="form-row">
                    <textarea name="message" id="message" value={formValues.message} onChange={handleChange} placeholder="Nachricht hinzufügen" className="inp inp-comments" ></textarea>
                </div>      
                <div className="form-row">
                    <button type="submit" className="form-btn">Absenden</button>
                    <div className={"form-feedback form-errors " + (errors ? " form-feedback-visible" : "")}>{errors}</div>
                    <div className={"form-feedback form-success " + (success ? " form-feedback-visible" : "")}>Ich freue mich auf dich.</div>
                </div>             
                
            </div>
        </form>
    )
    
}

export default ContactForm;